var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropertyIconTownhome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(337 773)",
    fill: "red"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-337 -773)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.313,2a.6.6,0,0,0-.427.2L2.181,6.21A.7.7,0,0,0,2,6.683v10.7a.7.7,0,0,0,.181.473.6.6,0,0,0,.437.2h14.82a.6.6,0,0,0,.437-.2.7.7,0,0,0,.181-.473V6.683a.7.7,0,0,0-.181-.473L14.169,2.2a.585.585,0,0,0-.873,0L10.027,5.737,6.759,2.2a.616.616,0,0,0-.2-.147A.576.576,0,0,0,6.313,2Zm.01,1.615L9.41,6.96v9.757H3.235V6.96Zm7.41,0L16.82,6.96v9.757H10.645V6.96ZM4.47,8.69v1.338H5.7V8.69Zm2.47,0v1.338H8.175V8.69Zm4.94,0v1.338h1.235V8.69Zm2.47,0v1.338h1.235V8.69ZM4.47,11.365V12.7H5.7V11.365Zm2.47,0V12.7H8.175V11.365Zm4.94,0V12.7h1.235V11.365Zm2.47,0V12.7h1.235V11.365ZM4.47,14.041v1.338H5.7V14.041Zm2.47,0v1.338H8.175V14.041Zm4.94,0v1.338h1.235V14.041Zm2.47,0v1.338h1.235V14.041Z",
    transform: "translate(336.973 772.973)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyIconTownhome);
export default __webpack_public_path__ + "static/media/property-icon-townhome.de1fbf10166fcf6daceb4565dadb1992.svg";
export { ForwardRef as ReactComponent };